export const TestHooks = {
  volume: 'volume',
  mute: 'mute',
  muteIcon: 'mute-icon',
  unMuteIcon: 'unmute-icon',
  volumeBarOn: 'volumebar-on',
  volumeBarOff: 'volumebar-off',
  play: 'play',
  playIcon: 'play-icon',
  pauseIcon: 'pause-icon',
} as const;
